function stickElem(stikyelement, bodyForElement , somePadding, headetIfstickyDesk, headetIfstickyMob){
    if (document.querySelector(stikyelement) !== null){
        let getStikyHead = document.querySelector(stikyelement);
        getStikyHead.style.transform = 'translateY('+ 0 + 'px)';
        let elemCoordinates = getStikyHead.getBoundingClientRect().top + pageYOffset;
        let getHeaderHeight;
        
        
        let soPa = somePadding;
        let elemHeight = getStikyHead.offsetHeight + soPa;
        if (headetIfstickyDesk !== undefined && headetIfstickyMob !== undefined){
            if (window.innerWidth > 767){
                getHeaderHeight = document.querySelector(headetIfstickyDesk).offsetHeight;
            }else{
                getHeaderHeight = document.querySelector(headetIfstickyMob).offsetHeight;
            }
        }else{
            getHeaderHeight = 0;
        }
        window.scrollBy(0,1);
        window.addEventListener('scroll', function() {
            let getBodyFormScroll = document.querySelector(bodyForElement).offsetHeight + elemCoordinates;
            let getBodyHeight = document.querySelector(bodyForElement).offsetHeight;
            let howMuchScroll = window.pageYOffset;
            let pxToScrollElem = howMuchScroll - elemCoordinates + getHeaderHeight;
            getStikyHead.classList.add('active');
            getStikyHead.style.zIndex = '100';
            getStikyHead.style.position = 'relative';
            soPa = somePadding;
            if (howMuchScroll < elemCoordinates){
                pxToScrollElem = 0;
                getStikyHead.classList.remove('active');
                soPa = 0;
            }
            if (howMuchScroll > getBodyFormScroll - elemHeight){
                pxToScrollElem = getBodyHeight - elemHeight;
                getStikyHead.classList.remove('active');
            }
            getStikyHead.style.transform = 'translateY('+ pxToScrollElem + 'px)';
            getStikyHead.style.paddingTop = `${soPa}px`;
        });
    }
}

module.exports = stickElem;